import LibrarySubjectsItem from './library-subjects-item'
import { SubjectsGrid } from './library-subjects.style'

const LibrarySubjects = () => {
    return (
        <SubjectsGrid>
            <LibrarySubjectsItem subject="Mathematics" imgUrl="/assets/images/subject/subject-maths.webp" />
            <LibrarySubjectsItem subject="English" imgUrl="/assets/images/subject/subject-english.webp" />
            <LibrarySubjectsItem subject="Chemistry" imgUrl="/assets/images/subject/subject-chemistry.webp" />
            <LibrarySubjectsItem subject="Physics" imgUrl="/assets/images/subject/subject-physics.webp" />
            <LibrarySubjectsItem subject="Computer Sci" imgUrl="/assets/images/subject/subject-compsci.webp" />
            <LibrarySubjectsItem subject="Biology" imgUrl="/assets/images/subject/subject-biology.webp" />
            <LibrarySubjectsItem subject="Intergrated Scicxn vkjdnfjkvnjkdnfjkvnjkdnfjkvnjkdnfjk" imgUrl="/assets/images/subject/subject-integrated-sci.webp" />
            <LibrarySubjectsItem subject="P.E" imgUrl="/assets/images/subject/subject-pe.webp" />
        </SubjectsGrid>
    )
}

export { LibrarySubjects }
